import type { O } from 'ts-toolbelt';
import type { ReadonlyDeep } from 'type-fest';

import {
  CodingConfigAutomaticInput,
  CodingConfigManualInput,
  CodingStrategyEnum,
} from '@e-socna/data-layer';
import type { CodingConfig, CodingConfigUnionInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

export function codingConfigForm2ApiMapper(
  codingConfig: ReadonlyDeep<O.Omit<CodingConfig, '_id' | 'strategy'>>,
): CodingConfigUnionInput {
  let codingConfigInput: CodingConfigUnionInput = {
    automatic: undefined,
    manual: undefined,
  };

  switch (codingConfig.kind) {
    case CodingStrategyEnum.CodingConfigAutomatic: {
      const prunedCodingConfig = pruneInput(
        codingConfig,
        CodingConfigAutomaticInput,
      );

      codingConfigInput = {
        automatic: prunedCodingConfig,
      };

      break;
    }
    case CodingStrategyEnum.CodingConfigManual: {
      const prunedCodingConfig = pruneInput(
        codingConfig,
        CodingConfigManualInput,
      );

      codingConfigInput = {
        manual: prunedCodingConfig,
      };

      break;
    }
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Unknown coding strategy: ${codingConfig.kind}`);
  }

  return codingConfigInput;
}
